export class CreateFarmsUseCase {
  constructor(farmsDapRepository) {
    this.farmsDapRepository=farmsDapRepository
  }
  async execute(farm_rows,ID_FARM) {
    // ID_FARM  -> ID do Cultivar
    //Verificar se existe cultivares com ID_FARM no banco
    const farms=await this.farmsDapRepository.showFarmsByIdFarmUseCase(ID_FARM)
    // Caso tenha então irá apagar eles do banco
    if(farms){
      await this.farmsDapRepository.deleteFarmsByIdFarmUseCase(ID_FARM)
    }

    const resp=await this.farmsDapRepository.create(farm_rows,ID_FARM)
    return resp
  }
}
